import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const StarFilledIcon = _ref => {
  let {
      size = "18",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  const aspectRatio = 16 / 15;
  const width = Number(size) * aspectRatio;
  return __jsx("svg", _extends({}, attributes, {
    width: size,
    height: size,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), __jsx("path", {
    d: "M4.06407 17.3731C3.62933 17.5965 3.13707 17.206 3.22459 16.7071L4.15803 11.3864L0.195412 7.6102C-0.174917 7.25729 0.0167837 6.61204 0.512897 6.54156L6.02368 5.7587L8.48082 0.891343C8.70216 0.452886 9.30175 0.452886 9.52309 0.891343L11.9802 5.7587L17.491 6.54156C17.9871 6.61204 18.1788 7.25729 17.8085 7.6102L13.8459 11.3864L14.7793 16.7071C14.8668 17.206 14.3746 17.5965 13.9398 17.3731L9.00195 14.8351L4.06407 17.3731Z",
    fill: color
  }));
};
export default StarFilledIcon;